import { notification } from 'antd';
import './notification.css';

export default notification;
